import React, { useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import useAuthStore from '../store/authStore';
import './Sidebar.css';

const Icon = ({ name, size = 20 }) => {
  const icons = {
    dashboard: <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><rect x="3" y="3" width="7" height="7"></rect><rect x="14" y="3" width="7" height="7"></rect><rect x="14" y="14" width="7" height="7"></rect><rect x="3" y="14" width="7" height="7"></rect></svg>,
    users: <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M17 21v-2a4 4 0 0 0-3-3.87"></path><path d="M9 21v-2a4 4 0 0 1 4-4h4a4 4 0 0 1 4 4v2"></path><circle cx="9" cy="7" r="4"></circle><path d="M23 21v-2a4 4 0 0 0-3-3.87"></path><path d="M16 3.13a4 4 0 0 1 0 7.75"></path></svg>,
    calendar: <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><rect x="3" y="4" width="18" height="18" rx="2" ry="2"></rect><line x1="16" y1="2" x2="16" y2="6"></line><line x1="8" y1="2" x2="8" y2="6"></line><line x1="3" y1="10" x2="21" y2="10"></line></svg>,
    fileText: <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"></path><polyline points="14 2 14 8 20 8"></polyline><line x1="16" y1="13" x2="8" y2="13"></line><line x1="16" y1="17" x2="8" y2="17"></line><polyline points="10 9 9 9 8 9"></polyline></svg>,
    trending: <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><polyline points="23 6 13.5 15.5 8.5 10.5 1 18"></polyline><polyline points="17 6 23 6 23 12"></polyline></svg>,
    settings: <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><circle cx="12" cy="12" r="3"></circle><path d="M19.4 15a1.65 1.65 0 0 0 .33 1.82l.06.06a2 2 0 0 1 0 2.83 2 2 0 0 1-2.83 0l-.06-.06a1.65 1.65 0 0 0-1.82-.33 1.65 1.65 0 0 0-1 1.51V21a2 2 0 0 1-2 2 2 2 0 0 1-2-2v-.09A1.65 1.65 0 0 0 9 19.4a1.65 1.65 0 0 0-1.82.33l-.06.06a2 2 0 0 1-2.83 0 2 2 0 0 1 0-2.83l.06-.06a1.65 1.65 0 0 0 .33-1.82 1.65 1.65 0 0 0-1.51-1H3a2 2 0 0 1-2-2 2 2 0 0 1 2-2h.09A1.65 1.65 0 0 0 4.6 9a1.65 1.65 0 0 0-.33-1.82l-.06-.06a2 2 0 0 1 0-2.83 2 2 0 0 1 2.83 0l.06.06a1.65 1.65 0 0 0 1.82.33H9a1.65 1.65 0 0 0 1-1.51V3a2 2 0 0 1 2-2 2 2 0 0 1 2 2v.09a1.65 1.65 0 0 0 1 1.51 1.65 1.65 0 0 0 1.82-.33l.06-.06a2 2 0 0 1 2.83 0 2 2 0 0 1 0 2.83l-.06.06a1.65 1.65 0 0 0-.33 1.82V9a1.65 1.65 0 0 0 1.51 1H21a2 2 0 0 1 2 2 2 2 0 0 1-2 2h-.09a1.65 1.65 0 0 0-1.51 1z"></path></svg>,
    briefcase: <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><rect x="2" y="7" width="20" height="14" rx="2" ry="2"></rect><path d="M16 21V5a2 2 0 0 0-2-2h-4a2 2 0 0 0-2 2v16"></path></svg>,
    checkSquare: <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><polyline points="9 11 12 14 22 4"></polyline><path d="M21 12v7a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h11"></path></svg>,
    clock: <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><circle cx="12" cy="12" r="10"></circle><polyline points="12 6 12 12 16 14"></polyline></svg>,
    pieChart: <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M21.21 15.89A10 10 0 1 1 8 2.83"></path><path d="M22 12A10 10 0 0 0 12 2v10z"></path></svg>,
    layout: <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><rect x="3" y="3" width="18" height="18" rx="2" ry="2"></rect><line x1="3" y1="9" x2="21" y2="9"></line><line x1="9" y1="21" x2="9" y2="9"></line></svg>,
    maximize: <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M8 3H5a2 2 0 0 0-2 2v3m18 0V5a2 2 0 0 0-2-2h-3m0 18h3a2 2 0 0 0 2-2v-3M3 16v3a2 2 0 0 0 2 2h3"></path></svg>,
    logout: <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4"></path><polyline points="16 17 21 12 16 7"></polyline><line x1="21" y1="12" x2="9" y2="12"></line></svg>,
    chevronLeft: <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><polyline points="15 18 9 12 15 6"></polyline></svg>,
    chevronRight: <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><polyline points="9 18 15 12 9 6"></polyline></svg>
  };
  return icons[name] || null;
};

const Sidebar = () => {
  const [isCollapsed, setIsCollapsed] = useState(() => {
    return localStorage.getItem('sidebar-collapsed') === 'true';
  });
  const navigate = useNavigate();
  const location = useLocation();
  const user = useAuthStore((state) => state.user);

  const toggleSidebar = () => {
    const newState = !isCollapsed;
    setIsCollapsed(newState);
    localStorage.setItem('sidebar-collapsed', newState);
  };

  const getMenuItems = () => {
    if (user?.role === 'HR') {
      return [
        { label: 'Dashboard', path: '/dashboard', icon: 'dashboard' },
        { label: 'Team', path: '/team', icon: 'users' },
        { label: 'Attendance', path: '/hr/attendance', icon: 'calendar' },
        { label: 'Daysheets', path: '/daysheet', icon: 'fileText' },
        { label: 'Reports', path: '/reports', icon: 'pieChart' },
        { label: 'Settings', path: '/settings', icon: 'settings' },
      ];
    }
    if (user?.role === 'Operations Head') {
      return [
        { label: 'Dashboard', path: '/dashboard', icon: 'dashboard' },
        { label: 'Projects', path: '/projects', icon: 'briefcase' },
        { label: 'Tasks', path: '/tasks', icon: 'checkSquare' },
        { label: 'Team', path: '/team', icon: 'users' },
        { label: 'Team Management', path: '/team-management', icon: 'layout' },
        { label: 'Resources', path: '/resources', icon: 'maximize' },
        { label: 'Time Tracking', path: '/time', icon: 'clock' },
        { label: 'Clients', path: '/clients', icon: 'users' },
        { label: 'Attendance', path: '/ops/attendance', icon: 'calendar' },
        { label: 'Daysheets', path: '/daysheet', icon: 'fileText' },
        { label: 'Reports', path: '/reports', icon: 'pieChart' },
        { label: 'Settings', path: '/settings', icon: 'settings' },
      ];
    }
    if (user?.role === 'Project Manager') {
      return [
        { label: 'Dashboard', path: '/dashboard', icon: 'dashboard' },
        { label: 'Projects', path: '/projects', icon: 'briefcase' },
        { label: 'Tasks', path: '/tasks', icon: 'checkSquare' },
        { label: 'Time Tracking', path: '/time', icon: 'clock' },
        { label: 'Team Management', path: '/team-management', icon: 'layout' },
        { label: 'Resources', path: '/resources', icon: 'maximize' },
        { label: 'Gantt Chart', path: '/gantt', icon: 'trending' },
        { label: 'Clients', path: '/clients', icon: 'users' },
        { label: 'Attendance', path: '/pm/attendance', icon: 'calendar' },
        { label: 'Daysheets', path: '/daysheet', icon: 'fileText' },
        { label: 'Reports', path: '/reports', icon: 'pieChart' },
      ];
    }
    if (user?.role === 'Project Lead') {
      return [
        { label: 'Dashboard', path: '/dashboard', icon: 'dashboard' },
        { label: 'Projects', path: '/projects', icon: 'briefcase' },
        { label: 'Tasks', path: '/tasks', icon: 'checkSquare' },
        { label: 'Time Tracking', path: '/time', icon: 'clock' },
        { label: 'Team', path: '/team', icon: 'users' },
        { label: 'Gantt Chart', path: '/gantt', icon: 'trending' },
        { label: 'Attendance', path: '/lead/attendance', icon: 'calendar' },
        { label: 'Daysheets', path: '/daysheet', icon: 'fileText' },
        { label: 'Reports', path: '/reports', icon: 'pieChart' },
      ];
    }
    return [
      { label: 'Dashboard', path: '/dashboard', icon: 'dashboard' },
      { label: 'Tasks', path: '/tasks', icon: 'checkSquare' },
      { label: 'Time Tracking', path: '/time', icon: 'clock' },
      { label: 'Attendance', path: '/developer/attendance', icon: 'calendar' },
      { label: 'My Daysheet', path: '/daysheet', icon: 'fileText' },
    ];
  };

  const menuItems = getMenuItems();

  return (
    <div className={`sidebar ${isCollapsed ? 'collapsed' : ''}`}>
      <div className="sidebar-header">
        <div className="logo" onClick={() => navigate('/dashboard')}>
          <div className="logo-icon">TM</div>
          <span className="logo-text">TaskManager</span>
        </div>
        <button className="toggle-btn" onClick={toggleSidebar}>
          <Icon name={isCollapsed ? 'chevronRight' : 'chevronLeft'} size={18} />
        </button>
      </div>

      <nav className="sidebar-nav">
        {menuItems.map((item, index) => (
          <div
            key={index}
            className={`nav-item ${location.pathname === item.path ? 'active' : ''}`}
            onClick={() => navigate(item.path)}
            title={isCollapsed ? item.label : ''}
          >
            <div className="nav-icon">
              <Icon name={item.icon} size={20} />
            </div>
            <span className="nav-label">{item.label}</span>
          </div>
        ))}
      </nav>

      <div className="sidebar-footer">
        <div className="user-block">
          <div className="avatar-mini">
            {user?.name?.charAt(0) || 'U'}
          </div>
          <div className="user-details">
            <span className="user-name">{user?.name}</span>
            <span className="user-role">{user?.role}</span>
          </div>
        </div>
        <button
          className="logout-action"
          onClick={() => {
            useAuthStore.getState().logout();
            navigate('/login');
          }}
          title="Logout"
        >
          <Icon name="logout" size={18} />
          {!isCollapsed && <span>Logout</span>}
        </button>
      </div>
    </div>
  );
};

export default Sidebar;
